/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import BasePureComponent from 'utils/BasePureComponent'
import Modal from 'components/Modal'


export default class BasePureContainer extends BasePureComponent {
  constructor(props) {
    super(props)
    this._bind(
      '_renderModal',
      '_showModal', '_hideModal', '_showSecondModal', '_hideSecondModal',
      // to be deprecated
      '_toggleModal', '_secondToggleModal',
    )


    this.state = {
      modal: {
        visible: false,
        child: null,
        props: {}
      },
      secondModal: {
        visible: false,
        child: null,
        props: {}
      }
    }

  }

  _renderModal(props = {}) {
    const className = this.state.modal.visible ? 'Modal-visible' : 'Modal-hidden'
    return (
      <Modal
        className={className}
        {...this.state.modal.props}
      >
        { this.state.modal.child }
      </Modal>
    )
  }

  _renderSecondModal(props = {}) {
    const className = this.state.secondModal.visible ? 'Modal-visible' : 'Modal-hidden'
    return (
      <Modal
        className={className}
        {...this.state.secondModal.props}
      >
        { this.state.secondModal.child }
      </Modal>
    )
  }

  /*
  * Start deprecation os _toggleModal and _secondToggleModal
  */

  _showModal(child, props = {}) {
    this.setState({
      modal: {
        visible: true,
        child, props
      }
    })
  }

  _hideModal() {
    this.setState({
      modal: {
        visible: false,
        child: null,
        props: {}
      }
    })
  }

  _showSecondModal(child, props = {}) {
    this.setState({
      secondModal: {
        visible: true,
        child, props
      }
    })
  }

  _hideSecondModal() {
    this.setState({
      secondModal: {
        visible: false,
        child: null,
        props: {}
      }
    })
  }

  // in pro of readable code we must deprecate this method since name is wrong
  // this doesn't toggle anything 🤦🏻‍♂️
  _toggleModal(visible=false, child=null, props = {}) {
    visible ? this._showModal(child, props) : this._hideModal()
  }

  _secondToggleModal(visible=false, child=null, props = {}) {
    visible ? this._showSecondModal(child, props) : this._hideSecondModal()
  }

  getChildContext() {
    return {
      showModal: this._showModal,
      hideModal: this._hideModal,
      showSecondModal: this._showSecondModal,
      hideSecondModal: this._hideSecondModal,
      isModalVisible: this.state.modal.visible,
      isSecondModalVisible: this.state.secondModal.visible,

      // to be deprecated, at the moment I'll let this
      // due to the time it will take to refactor it
      toggleModal: this._toggleModal,
      secondToggleModal:  this._secondToggleModal,
    }
  }
}

BasePureContainer.childContextTypes = {
  toggleModal: PropTypes.func,
  secondToggleModal: PropTypes.func,
  showModal: PropTypes.func,
  hideModal: PropTypes.func,
  showSecondModal: PropTypes.func,
  hideSecondModal: PropTypes.func,
  isModalVisible: PropTypes.bool,
  isSecondModalVisible: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/utils/BasePureContainer.js